import { CvlFinancialQualificationCriteriaEnumType } from '__generated__/graphql';

export default function cvlQualificationCriteriaToReadable(
  criteria: CvlFinancialQualificationCriteriaEnumType
): {
  label: string;
  color: string;
} {
  switch (criteria) {
    case CvlFinancialQualificationCriteriaEnumType.AnnualIncome:
      return {
        label: 'Annual Income',
        color: 'blue',
      };
    case CvlFinancialQualificationCriteriaEnumType.NetWorth:
      return {
        label: 'Net Worth',
        color: 'purple',
      };
    case CvlFinancialQualificationCriteriaEnumType.Combined:
      return {
        label: 'Combined',
        color: 'indigo',
      };
    default:
      return {
        label: criteria,
        color: 'gray',
      };
  }
}
